import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-local-trusted-way-section',
  templateUrl: './trusted-way-section.component.html',
  styleUrls: ['./trusted-way-section.component.scss'],
  imports: [CommonModule],
})
export class LocalTrustedWaySectionComponent implements OnInit, OnChanges {
  @Input() pageData:any;
  @Input() hasInside: boolean = false;
  trustedWaySectionData: any;

  private updateTrustedWaySectionData(): void {
    const data = this.pageData?.customersStatsContentPanel?.fields;
    if (data) {
      this.trustedWaySectionData = {
        icons: data?.image,
        header: data?.title,
      };
    }
  }

  ngOnInit(): void {
    this.updateTrustedWaySectionData();
  }
  ngOnChanges(): void {
    this.updateTrustedWaySectionData();
  }
}
